"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const apollo_link_error_1 = require("apollo-link-error");
const utils_1 = __importDefault(require("../../utils"));
exports.default = options => (0, apollo_link_error_1.onError)(_ref => {
  let networkError = _ref.networkError;
  const statusCode = (0, utils_1.default)(networkError);
  if (statusCode === 401) {
    options.tokenInvalid();
  }
});